import { ProgramFinancialSideBarFiltersDatamodelType } from '../side-bar-filter/program-financial-side-bar-filters-datamodel.type';
import appApi from '../../../../../api/app-api';
import { ProgramComparisonAmongBranchesDb } from '../../../../../api/types/reports/finanace/program-comparison-among-branches';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getProgramFinancialDataOperations = async (
  filters: ProgramFinancialSideBarFiltersDatamodelType,
  setData: (data: ProgramComparisonAmongBranchesDb[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getProgramComparisonByBranches(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};
